// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../config-global';
// components
import { useSettingsContext } from '../../components/settings';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          height: 1,
          maxWidth: 1,
          pt: `${HEADER.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            pt: `${HEADER.H_DASHBOARD_DESKTOP + 80}px`,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        height: 1,
        maxWidth: 1,
        pt: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          maxWidth: themeLayout === 'vertical' ? `calc(100% - ${NAV.W_DASHBOARD}px)` : '100%',
          pt: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: 1,
          ...(isNavMini && {
            width: 1,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
